import React from "react";
import PropTypes from "prop-types";
import RefreshCwIcon from "../Icons/RefreshCwIcon";
import "../styles/seriesPillStyles.css";

const ICON_SIZE = { sm: 8, md: 10 };

const SeriesPill = ({ size }) => {
  const iconSize = ICON_SIZE[size] || ICON_SIZE.sm;
  return (
    <span className={`series-pill series-pill-${size} d-inline-flex align-items-center`}>
      <RefreshCwIcon fill="#1982C4" width={String(iconSize)} height={String(iconSize)} />
      SERIES
    </span>
  );
};

SeriesPill.propTypes = {
  size: PropTypes.oneOf(["sm", "md"]),
};

SeriesPill.defaultProps = {
  size: "sm",
};

export default SeriesPill;
